export class ApiError extends Error {
  status: object;

  constructor(message: string, status: object) {
    super(message);
    this.status = status;
  }
}
